import React from 'react';
import loadable from '@loadable/component';

import editorialContentPageQuery from './query.graphql';

const EditorialContent = loadable(() =>
  import(/* webpackChunkName: "article" */ './editorial-content')
);

const EditorialContentPage = ({ data }) => (
  <EditorialContent data={data.prismicArticle} />
);

EditorialContentPage.graphQL = editorialContentPageQuery;

EditorialContentPage.variables = vars => {
  // Prismic preview feature sends this parameter
  // then we send that along to the Prismic API integration
  // as the `ref` option. This lets us preview unpublished
  // articles.
  if (vars.token) {
    return {
      id: vars.documentId,
      ref: vars.token,
    };
  }

  return vars;
};

export default EditorialContentPage;
